import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useEffect, useRef, useState } from 'preact/hooks'
import { collectionGroupConfig } from '../config'

import NoResults from '../serp/NoResults'
import Products from '../serp/Products'
import Toolbar from '../serp/Toolbar'
import Sidebar from '../serp/Sidebar'
import BottomToolbar from '../serp/BottomToolbar'
import Loader from '../serp/Loader'

export default () => {
    const { response: { products }, loading } = useAppState();
    const [ sidebarActive, setSidebarActive ] = useState(false);
    const foundProducts = products && products.total > 0;
    const collectionGroups = collectionGroupConfig[products?.categoryId];
    const serpRef = useRef(null);

    useEffect(() => {
        if(!serpRef.current) return;
        if (sidebarActive && window.innerWidth < 1024) {
            document.querySelector('body').style.overflow = 'hidden'
            serpRef.current.style.zIndex = '10'
        } else {
            document.querySelector('body').style.overflow = 'initial'
            serpRef.current.style.zIndex = 'unset'
        }
    }, [ sidebarActive ])

    const toggleSidebar = () => {
        setSidebarActive(!sidebarActive);
    }

    return (
        <div class="ns-serp ns-font-inherit" data-nosto-element="search" ref={serpRef}>
            {loading && !foundProducts ? (
                <Loader />
            ) : foundProducts ? (
                <>
                    <Toolbar
                        toggleSidebar={toggleSidebar} 
                        collectionGroups={collectionGroups}
                    />
                    <div class="ns-body-container flex flex-col" style={loading ? 'position: relative;' : ''} >
                        <Sidebar 
                            sidebarActive={sidebarActive} 
                            toggleSidebar={toggleSidebar} 
                        />
                        <Products
                            sidebarActive={sidebarActive} 
                            collectionGroups={collectionGroups}
                        />
                    </div>
                    <BottomToolbar
                        isGroupedCollection={!!collectionGroups}
                    />
                </>
            ) : (
                <NoResults />
            )}
        </div>
    )
}
